// AEHSFooter.js
import React from 'react';
import TikTokIcon from './icons/TikTokIcon';
import InstaIcon from './icons/InstaIcon.js';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import './AEHS.css';
import facebookIcon from '../../../../src/assets/images/fb icon.png';

const AEHSFooter = () => {
  return (
    <footer className="AEHSfooter">
      <div className='aehsWebFooter'>
        <div className='footertxt1' style={{ fontSize: '16px' }}>Asian Elite Hotel School<div className='footertxt4'>&nbsp; &#x25CF;</div></div>
        <div className='footertxt2'>Get in Touch with Us</div>
        <div className='footerContactData'>
          <p className='footertxt2'><EmailIcon /> Email: info@asianexotica.lk</p>
          <p className='footertxt2'><PhoneIcon /> Telephone: 077 730 5244/ 011 257 6881</p>
          <p className='footertxt2'><LocationOnIcon /> Address: 55B, Ananda Coomaraswamy Mawatha, Colombo, Sri Lanka, 00300</p>
        </div>
        <hr />
        <div className='footerBottomSection'>
          <div className='footercredit'>
            <div className='footertxt2'>© 2024 Asian Elite Hotel School.</div>
            <div className='footertxt3'>Powered by Infinity Innovators(Pvt) Ltd</div>
          </div>
        </div>
      </div>

      <div className='aehsMobileFooter'>
        <div className='footertxt1'>Asian Elite Hotel School<div className='footertxt4'>&nbsp; &#x25CF;</div></div>
        <div className='footertxt2'>Get in Touch with Us</div>
        <div className=''>
          <p className='footertxt2'><EmailIcon /> Email: info@asianexotica.lk</p>
          <p className='footertxt2'><PhoneIcon /> Telephone: 077 730 5244/ 011 257 6881</p>
          <p className='footertxt2'><LocationOnIcon /> Address: 55B, Ananda Coomaraswamy Mawatha, Colombo, Sri Lanka, 00300</p>
        </div>
        <hr />
        <div className='footerBottomSection'>
          <div className='footercredit'>
            <div className='footertxt2'>© 2024 Asian Elite Hotel School.</div>
            <div className='footertxt3'>Powered by Infinity Innovators(Pvt) Ltd</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AEHSFooter;
